import { Card } from './PanelCard.styles';
import type { PanelCardProps } from './PanelCard.types';

export function PanelCard({ children, size = 'medium' }: PanelCardProps) {
  return <Card data-size={size === 'medium' ? undefined : size}>{children}</Card>;
}
